import { useEffect, useState } from "react";
import { getPartnerAll } from "tm-shared/api";
import { Option } from "tm-shared/types";

import Header from "@/components/Header";
import { MainContainer } from "@/components/Layout/Styled";
import { PrimaryText } from "@/components/Typography/Styled";
import { CreateMarketFormSkeleton } from "@/pages/SV/MarketCreate/CreateMarketForm/CreateMarketForm.Skeleton";

import { CreateMarketForm } from "./CreateMarketForm";
import { ModalsContainer } from "./ModalsContainer";

const MarketCreatePage = () => {
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState<string | null>(null);
    const [partnerOptions, setPartnerOptions] = useState<Option[]>([]);

    useEffect(() => {
        const controller = new AbortController();

        const fetchPartners = async () => {
            try {
                setLoading(true);
                setError(null);

                const res = await getPartnerAll({ cityName: null });

                const options = res.result.partners.map(({ id, name }) => ({
                    value: id,
                    label: name,
                }));

                setPartnerOptions(options);
            } catch (err) {
                if (err instanceof Error && err.name === "AbortError") {
                    return;
                }
                console.error("Failed to fetch partners:", err);
                setError("Не вдалося завантажити список партнерів");
            } finally {
                setLoading(false);
            }
        };

        fetchPartners();

        return () => controller.abort();
    }, []);

    return (
        <>
            <Header title="Створити ТТ" back />

            <MainContainer>
                {!loading && !error && (
                    <>
                        <CreateMarketForm partnerOptions={partnerOptions} />

                        <ModalsContainer />
                    </>
                )}

                {loading && <CreateMarketFormSkeleton />}

                {error && !loading && (
                    <PrimaryText
                        textAlign="center"
                        $textColor="error"
                        fontSize={16}
                    >
                        {error}
                    </PrimaryText>
                )}
            </MainContainer>
        </>
    );
};

export default MarketCreatePage;
